<template>
  <div class="json-viewer">
    <div v-for="(value, key) in data" :key="key" class="json-item">
      <strong class="json-key">{{ key }}:</strong>
      <span v-if="isPrimitive(value)" class="json-value-primitive">
        {{ formatPrimitive(value) }}
      </span>
      <JsonViewer v-else :data="value" class="json-value-nested" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'JsonViewer', // Nome del componente per l'uso ricorsivo
  props: {
    data: {
      type: [Object, Array],
      required: true,
    },
  },
  methods: {
    isPrimitive(value) {
      return typeof value !== 'object' || value === null;
    },
    formatPrimitive(value) {
      if (typeof value === 'string') {
        return `"${value}"`; // Aggiunge virgolette per le stringhe
      }
      return value;
    },
  },
};
</script>

<style scoped>
.json-viewer {
  font-family: monospace;
  font-size: 14px;
  line-height: 1.5;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  white-space: pre-wrap; /* Mantiene la formattazione */
}

.json-item {
  margin-left: 20px;
}

.json-key {
  color: #333;
}

.json-value-primitive {
  color: #0077aa; /* Colore per i valori */
}
</style>